import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ErrorMessage(props) {
  var {
    message
  } = props;
  return useMemo(() => {
    if (!message) return null;
    return /*#__PURE__*/_jsx("pre", {
      children: /*#__PURE__*/_jsx("code", {
        children: message
      })
    });
  }, [message]);
}